import React from 'react';
import { Loader2 } from 'lucide-react';

/**
 * Job areas / categories badge toggles.
 *
 * Props:
 *   selected: string[] currently selected areas
 *   available: string[] full list to render as toggleable buttons
 *   onToggle(area): callback to flip a single area in/out of selection
 *   loading: bool - show spinner instead of buttons
 *   testIdPrefix: defaults to "job-area"
 *   scrollable: limits height with scroll (used in compact dashboard variant)
 *   buttonSize: "lg" or "sm"
 */
export const JobAreasField = ({
  selected = [],
  available = [],
  onToggle,
  loading = false,
  testIdPrefix = 'job-area',
  scrollable = false,
  buttonSize = 'lg',
}) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center py-4">
        <Loader2 className="w-5 h-5 animate-spin text-slate-400" />
        <span className="ml-2 text-sm text-slate-500">Lade Kategorien...</span>
      </div>
    );
  }

  const sizeCls = buttonSize === 'lg' ? 'px-4 py-2' : 'px-3 py-1.5';
  const wrapCls = scrollable
    ? 'flex flex-wrap gap-2 max-h-40 overflow-y-auto'
    : 'flex flex-wrap gap-2';

  return (
    <div className={wrapCls}>
      {available.map((area) => {
        const active = selected.includes(area);
        return (
          <button
            key={area}
            type="button"
            onClick={() => onToggle(area)}
            className={`${sizeCls} rounded-full text-sm transition-all ${
              active
                ? 'bg-primary text-white shadow-lg'
                : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
            }`}
            data-testid={`${testIdPrefix}-${area}`}
          >
            {area}
          </button>
        );
      })}
    </div>
  );
};
